import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22043766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "events-log" }
const _hoisted_2 = { class: "events-log__item-date" }
const _hoisted_3 = { class: "events-log__item-line" }
const _hoisted_4 = {
  key: 0,
  class: "i"
}
const _hoisted_5 = { class: "events-log__item-content" }
const _hoisted_6 = { class: "events-log__content-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "events-log__content-desc" }
const _hoisted_9 = {
  key: 0,
  class: "content-desc__opt-user"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "content-desc__line" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "content-desc__reason"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "content-desc__reason"
}
const _hoisted_14 = {
  class: "content-desc__reason",
  style: {"margin-top":"0"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "content-desc__line" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "content-desc__reason"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "content-desc__reason"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 3,
  class: "content-desc__reason"
}
const _hoisted_22 = {
  key: 4,
  class: "events-log__content-desc"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "content-desc__line" }, null, -1))
const _hoisted_24 = { class: "content-desc__reason" }
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (log, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "events-log__item",
        key: log.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", null, _toDisplayString(_ctx.moment("20" + log.opt_time_name).format("HH:mm")), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.moment("20" + log.opt_time_name).format("YY-MM-DD")), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("b", {
            class: _normalizeClass({ first: index == 0 })
          }, null, 2),
          (index != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                size: "14",
                color: "#3d6eeb",
                name: "checked"
              })),
          _createElementVNode("span", {
            class: _normalizeClass({ last: index == _ctx.state.list.length - 1 })
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (log.opt_uid_array.length > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(log.opt_uid_array[0].department_name) + " - " + _toDisplayString(log.opt_uid_array[0].name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("b", null, _toDisplayString(_ctx.eventsNames[log.opt_type]), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (log.opt_type == 7 && log.obj_uids_array.length > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9, _toDisplayString(log.obj_uids_array[0].department_name) + " - " + _toDisplayString(log.obj_uids_array[0].name) + " 等" + _toDisplayString(log.obj_uids_array.length) + "人 ", 1))
              : _createCommentVNode("", true),
            (log.opt_type == 1 || log.opt_type == 2 || log.opt_type == 24 || log.opt_type == 25)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_10,
                  (log.close_reason == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createTextVNode(" 关闭原因：重复事件 "),
                        (log.event_array.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" ("),
                              _createElementVNode("i", {
                                onClick: ($event: any) => (
                    _ctx.$router.push({
                      name: _ctx.$RouterName.EVENTS_DETAIL,
                      params: {
                        id: log.event_array[0].id
                      }
                    })
                  )
                              }, _toDisplayString(log.event_array[0].event_code), 9, _hoisted_12),
                              _createTextVNode(") ")
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(log.show_content), 1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(" 备注：" + _toDisplayString(log.opt_content || "-") + " ", 1),
                    (log.pic_ids_array.length > 0)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.ImagePreview(log.pic_ids_array.map(pic => pic.photo_file)))
                        }, "查看图片", 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (log.opt_type == 9 || log.opt_type == 10)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_16,
                  (log.opt_type == 10)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createTextVNode(" 审批编号： "),
                        (log.approval_array.length > 0)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (
                    _ctx.$router.push({
                      name: _ctx.$RouterName.APPROVAL_DETAIL,
                      params: {
                        id: log.approval_array[0].id
                      }
                    })
                  )
                            }, _toDisplayString(log.approval_array[0].code), 9, _hoisted_18))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (log.opt_type == 9)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createTextVNode(" 工单编号： "),
                        (log.workorder_array.length > 0)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.toGuaranteeDetil(log.workorder_array[0].id))
                            }, _toDisplayString(log.workorder_array[0].orderid), 9, _hoisted_20))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (log.opt_type == 14 && log.obj_uids_array.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.obj_uids_array, (user, userIndex) => {
                    return (_openBlock(), _createElementBlock("i", {
                      class: "content-desc__opt-user",
                      key: user.id
                    }, [
                      _createTextVNode(_toDisplayString(user.department_name) + " - " + _toDisplayString(user.name) + " ", 1),
                      (userIndex != log.obj_uids_array.length - 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" ， ")
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (log.opt_type == 18 || log.opt_type == 12 || log.opt_type == 11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(" 备注：" + _toDisplayString(log.opt_content || "-") + " ", 1),
                    (log.pic_ids_array.length > 0)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.ImagePreview(log.pic_ids_array.map(pic => pic.photo_file)))
                        }, "查看图片", 8, _hoisted_25))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}